import { setInputTestId } from "@bcc/components/ui/input/input.utils";
import { generateTestId } from "@client-shared";
import { ADDRESS_MAX_LENGTH, ADDRESS_SPLIT_LENGTH } from "@shared/schemas";

export function splitStreetAddress(full: string): {
  address1: string;
  address2: string;
} {
  const trimmed = full.trim();
  if (trimmed.length <= ADDRESS_MAX_LENGTH) {
    return { address1: trimmed, address2: "" };
  }
  const splitAt = trimmed.lastIndexOf(" ", ADDRESS_SPLIT_LENGTH);
  const cut = splitAt > 0 ? splitAt : ADDRESS_SPLIT_LENGTH;
  return {
    address1: trimmed.slice(0, cut).trimEnd(),
    address2: trimmed.slice(cut).trimStart(),
  };
}

export const setProfilePreferencesTestId = (identifier: string): string => generateTestId("ProfilePreferences", identifier);

export const setProfilePreferencesContainerTestId = (): string => setProfilePreferencesTestId("container");

export const setProfilePreferencesTitleTestId = (): string => setProfilePreferencesTestId("title");

export const setProfilePreferencesDescriptionTestId = (): string => setProfilePreferencesTestId("description");

export const setProfilePreferencesRoasterInfoCardTestId = (): string => setProfilePreferencesTestId("roaster-info-card");

export const setProfilePreferencesRoasterInfoTitleTestId = (): string => setProfilePreferencesTestId("roaster-info-title");

export const setProfilePreferencesRoasterInfoDescriptionTestId = (): string => setProfilePreferencesTestId("roaster-info-description");

export const setProfilePreferencesBillingAddressCardTestId = (): string => setProfilePreferencesTestId("billing-address-card");

export const setProfilePreferencesBillingAddressTitleTestId = (): string => setProfilePreferencesTestId("billing-address-title");

export const setProfilePreferencesBillingAddressDescriptionTestId = (): string =>
  setProfilePreferencesTestId("billing-address-description");

export const setProfilePreferencesShippingAddressCardTestId = (): string => setProfilePreferencesTestId("shipping-address-card");

export const setProfilePreferencesShippingAddressTitleTestId = (): string => setProfilePreferencesTestId("shipping-address-title");

export const setProfilePreferencesShippingAddressDescriptionTestId = (): string =>
  setProfilePreferencesTestId("shipping-address-description");

export const setProfilePreferencesProfileInfoCardTestId = (): string => setProfilePreferencesTestId("profile-info-card");

export const setProfilePreferencesProfileInfoTitleTestId = (): string => setProfilePreferencesTestId("profile-info-title");

export const setProfilePreferencesProfileInfoDescriptionTestId = (): string => setProfilePreferencesTestId("profile-info-description");

export const setProfilePreferencesPersonaCardTestId = (): string => setProfilePreferencesTestId("persona-card");

export const setProfilePreferencesPersonaTitleTestId = (): string => setProfilePreferencesTestId("persona-title");

export const setProfilePreferencesPersonaDescriptionTestId = (): string => setProfilePreferencesTestId("persona-description");

export const setProfilePreferencesLogoSectionTestId = (): string => setProfilePreferencesTestId("logo-section");

export const setProfilePreferencesChooseFileButtonTestId = (): string => setProfilePreferencesTestId("choose-file-button");

export const setProfilePreferencesSaveChangesButtonTestId = (): string => setProfilePreferencesTestId("save-changes-button");

// Profile info input field test IDs (generated from RHF field names)
export const setProfilePreferencesFirstNameInputTestId = (): string => setInputTestId("firstName");

export const setProfilePreferencesLastNameInputTestId = (): string => setInputTestId("lastName");

export const setProfilePreferencesPhoneInputTestId = (): string => setInputTestId("phone");

// Shipping address input field test IDs (generated from RHF field names)
export const setProfilePreferencesShippingStreetInputTestId = (): string => setInputTestId("shippingAddress.address1");

export const setProfilePreferencesShippingCityInputTestId = (): string => setInputTestId("shippingAddress.city");

export const setProfilePreferencesShippingZipInputTestId = (): string => setInputTestId("shippingAddress.zip");
